import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';
import './SchoolLogin.css';

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/schoollogin?reset=true`
      });

      if (error) {
        setError('Error sending reset email. Please try again.');
      } else {
        setMessage('Password reset email sent! Check your inbox and follow the instructions to reset your password.');
        setEmail('');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError('Error sending reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="school-login-container">
      <div className="school-login-card">
        <div className="school-login-header">
          <h1>Reset Password</h1>
          <p>Enter your email to receive a password reset link</p>
        </div>
        
        <form onSubmit={handleSubmit} className="school-login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your school email"
              required
            />
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          {message && (
            <div className="success-message">
              {message}
            </div>
          )}
          
          <button 
            type="submit" 
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Remember your password?</p>
          <button 
            className="back-btn"
            onClick={() => navigate('/schoollogin')}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;







